import { render } from "./NaturalGas.vue?vue&type=template&id=d329ca12&ts=true"
import script from "./NaturalGas.vue?vue&type=script&lang=ts"
export * from "./NaturalGas.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__